<template>
  <div>
    {{label || title}}
    <div class="pl-2 pr-2 pt-2 pb-2">

      <template v-if="!is_external_team_list">
        <list-select name="team_list" label="Team list" filter="team" v-model="val"></list-select>
      </template>

      <label>Final:</label>
      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="final_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="final_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; line-height: 60px;"> VS </k-flex>
        <k-flex c1><text-field name="final_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="final_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="final_text" label="Final text" v-model="val"></text-field>
        </k-flex>


      </k-layout>

      <label>Bronze:</label>
      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="bronze_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="bronze_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; line-height: 60px;"> VS </k-flex>
        <k-flex c1><text-field name="bronze_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="bronze_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="bronze_text" label="Bronze text" v-model="val"></text-field>
        </k-flex>

      </k-layout>

      Semifinals:
      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="sf1_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="sf1_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; margin-top: 10px;"> QF1 - QF2<br/>VS </k-flex>
        <k-flex c1><text-field name="sf1_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="sf1_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="sf1_text" label="SF1 text" v-model="val"></text-field>
        </k-flex>
      </k-layout>

      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="sf2_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="sf2_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; margin-top: 10px;"> QF3 - QF4<br/>VS </k-flex>
        <k-flex c1><text-field name="sf2_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="sf2_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="sf2_text" label="SF2 text" v-model="val"></text-field>
        </k-flex>

      </k-layout>


      Quarter finals:

      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf1_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="qf1_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; margin-top: 10px;"> QF1<br/>VS </k-flex>
        <k-flex c1><text-field name="qf1_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf1_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="qf1_text" label="QF1 text" v-model="val"></text-field>
        </k-flex>

      </k-layout>
      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf2_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="qf2_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; margin-top: 10px;"> QF2<br/>VS </k-flex>
        <k-flex c1><text-field name="qf2_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf2_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="qf2_text" label="QF2 text" v-model="val"></text-field>
        </k-flex>

      </k-layout>
      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf3_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex> 
        <k-flex c1><text-field name="qf3_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; margin-top: 10px;"> QF3<br/>VS </k-flex>
        <k-flex c1><text-field name="qf3_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf3_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="qf3_text" label="QF3 text" v-model="val"></text-field>
        </k-flex>


      </k-layout>
      <k-layout row wrap class="elevation-2 mb-4 pl-2" style="background: rgba(0,0,0,0.1);">        
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf4_home" label="Home" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>
        <k-flex c1><text-field name="qf4_home_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c2 class="pr-1" style="text-align: center; margin-top: 10px;"> QF4<br/>VS </k-flex>

        <k-flex c1><text-field name="qf4_away_score" label="Score" v-model="val"></text-field></k-flex>
        <k-flex c4 class="pr-1">
          <content-select from="team_list" name="qf4_away" label="Away" v-model="val" content_type="internal" item-value="id"></content-select>
        </k-flex>

        <k-flex c12>
          <text-field name="qf4_text" label="QF4 text" v-model="val"></text-field>
        </k-flex>


      </k-layout>
    </div>
  </div>
</template>
  
<script>
import * as FormItems from '.'
import ContentModel from '@/models/content.js'


export default {
	props: {
		'name': String,
	  'value': {
      type: Object,
      default () { return {}; }
    },
    "team_list": String,
		'label': String,
    'title': String
	},
  data() {
    return {
      current_team_list: undefined
    };
  },  
  components: {
    ...FormItems
  },
  watch: {
    value (newVal, oldVal) {
      if (this.is_external_team_list) {
        var list_id = _.get(this.value, this.team_list);
        this.current_team_list = list_id;
      }
    }
  },
  mounted: function() {
    if (this.is_external_team_list) {
        var list_id = _.get(this.value, this.team_list);
        this.current_team_list = list_id;
    }
  },
	computed: {
    is_external_team_list () {
      if (typeof(this.team_list) != "undefined") return true;
      return false;
    },
    val: {
      get () {
        var ret = _.get(this.value, this.name) || {};
        ret["team_list"] = this.current_team_list;
        return ret;
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
